import LinePlusIcon from 'components/Luxkit/Icons/line/LinePlusIcon'
import Caption from 'components/Luxkit/Typography/Caption'
import Group from 'components/utils/Group'
import React from 'react'

interface Props {
  locations: string[];
}

export default function BundleAndSaveLocation(props: Props) {
  return (
    <Group direction="horizontal" verticalAlign="center" gap={4}>
      {props.locations.map((location, index) => <React.Fragment key={location}>
        {index > 0 && <LinePlusIcon colour="neutral-one" size={12} />}
        <Caption variant="large" colour="neutral-one">{location}</Caption>
      </React.Fragment>)}
    </Group>
  )
}
